<template>
  <div class="page_warpper">
    <div class="toolbar">
      <ui-select
        disable-filter
        has-search
        label="Wine"
        placeholder="Please select"
        search-placeholder="code or name"
        :loading="select11Loading"
        :no-results="select11NoResults"
        :options="select11Options"
        @query-change="onQueryChange"
        @select="onSelect"
        v-model="select11"
      ></ui-select>
      <ui-radio-group
        style="margin-left:30px;"
        name="group1"
        :options="[
          { label: 'English', value: 'en' },
          { label: '简体中文', value: 'zh' }
        ]"
        v-model="currentLang"
        @change="onLangChange"
        >&nbsp;</ui-radio-group
      >
    </div>

    <div style="border: 1px solid #000;">      
      <div id="product_warpper">
        <div class="logo" v-if="currentProduct != null">
          <img src="@/assets/images/megalogo_1.jpg" alt="Image" style="height:100px;" /><br/>
          <p>{{currentLang === 'en'?'Mega Wine':'蜜蒂酒业'}}</p>
        </div>
        <div class="product_pic" v-if="currentProduct != null">
          <img :src="currentProduct.image" alt="Image" style="height:400px;" />
        </div>
        <div class="product_desc" v-if="currentProduct != null">
          <p class="title">
            {{ currentProduct.productName }}
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Appellation' : '产区' }}：</span
            >{{ currentProduct.region || '' }}
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Type' : '品种' }}：</span
            >{{ currentProduct.productType }}
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Varieties' : '葡萄品种' }}：</span
            >{{ currentProduct.grapes || '' }}
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Size' : '规格' }}：</span
            >750ml
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Alcohol Volume' : '酒精度' }}：</span
            >{{ currentProduct.alcohol || '' }}%vol
          </p>
          <p>
            <span class="label">{{
              currentLang === 'en' ? 'Bouteille' : '入瓶'
            }}</span
            >：{{ currentLang === 'en' ? 'Au Chateau' : '酒庄入瓶' }}
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Price' : '价格' }}：</span
            >{{ currentProduct.currencyKind + currentProduct.price }}
          </p>
          <p style="display:flex;">
            <span class="label" style="display:block;"
              >{{ currentLang === 'en' ? 'Tasting' : '品鉴说明' }}：</span
            ><span style="flex:1;">{{ currentProduct.tastingNote || '' }}</span>
          </p>
        </div>
      </div>
    </div>
    <br />
    <ui-button color="primary" @click="test">生成圖片</ui-button>
    <LayerVue
      :visible.sync="show"
      :shadeClose="true"
      :title="false"
      :shade="true"
      :area="['1024px', '750px']"
    >
      <div id="poster_warpper"></div>
      <div style="text-align:center;">
        <ui-button color="primary" @click="download">下載</ui-button>
        <a id="link"></a>
      </div>
    </LayerVue>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import debounce from 'lodash.debounce'
export default {
  data() {
    return {
      show: false,
      currentCanvas: null,
      select11: '',
      select11Options: [],
      select11Loading: false,
      select11NoResults: false,
      select11LoadingTimeout: null,
      currentProduct: null,
      currentLang: 'en'
    }
  },
  methods: {
    onQueryChange(query) {
      if (query.length === 0) {
        return
      }
      this.fetchRemoteResults(query)
    },
    fetchRemoteResults: debounce(function(query) {
      this.select11Loading = true
      this.queryProducts(query)
    }, 500),
    onSelect(item, selected) {
      this.getProduct(item)
    },
    getProduct(product) {
      const _this = this
      this.$http
        .get('/api/product/GetProductByPoster', {
          ProductGuid: product.productGUID,
          lang: this.currentLang
        })
        .then(res => {
          _this.currentProduct = res.data
          _this.currentProduct.tastingNote = _this.currentProduct.tastingNote.replace(
            /\([^\)]*\)/g,
            ''
          )
          if(_this.currentProduct.image){
            _this.currentProduct.image=_this.currentProduct.image.replace('wine-dream','mega-wine')+'?rnd='+Math.random()
          }else{
            _this.currentProduct.image='http://www.mega-wine.com/img/default279x900.86410399.png'
          }

          if(_this.currentProduct.imgthumb){
            _this.currentProduct.imgthumb=_this.currentProduct.imgthumb.replace('wine-dream','mega-wine')+'?rnd='+Math.random()
          }else{            
            _this.currentProduct.imgthumb='http://www.mega-wine.com/img/default279x900.86410399.png'
          }
        })
    },
    queryProducts(query) {
      let _this = this
      this.$http
        .get('/api/product/QueryProductByPoster', {
          keyword: query
        })
        .then(res => {
          _this.select11Loading = false
          _this.select11Options = res.data.products.map(item => {
            item.label = item.productName
            return item
          })
        })
    },
    onLangChange(newVal) {
      this.currentLang = newVal
      if (this.currentProduct != null) {
        this.getProduct(this.currentProduct)
      }
    },
    test() {
      const _this = this
      html2canvas(document.querySelector('#product_warpper'), {
        useCORS: true,
        logging: true
      }).then(function(canvas) {
        //document.body.appendChild(canvas)
        document.querySelector('#poster_warpper').innerHTML = ''
        document.querySelector('#poster_warpper').appendChild(canvas)
        _this.currentCanvas = canvas
        _this.show = true
      })
    },
    download() {
      var link = document.getElementById('link')
      link.setAttribute(
        'download',
        this.currentProduct.productName.replace(/\s+/g, '_') + '.png'
      )
      link.setAttribute(
        'href',
        this.currentCanvas
          .toDataURL('image/png')
          .replace('image/png', 'image/octet-stream')
      )
      link.click()
    }
  }
}
</script>

<style lang="scss" scoped>
.page_warpper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .toolbar {
    display: flex;
    justify-content: flex-start;
  }
}
#product_warpper {
  //border: 1px solid #000;
  display: flex;
  justify-content: flex-start;
  width: 1004px;
  height: 600px;
  padding: 20px 40px;
  position:relative;
  background: url('~@/assets/images/poster_bg.jpg') repeat 0 0;
  .logo{
    position: absolute;
    left:10px;
    top:10px;
    text-align:center;
    line-height: 0;
    color:#ab8a62;
    font-size: 14px;
  }
  .product_pic {
    display: flex;
    justify-content: right;
    align-items: center;
    width: 350px;
    margin-right:50px;
  }
  .product_desc {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    width: 600px;
    padding-right: 50px;
    font-size: 14px;
    .title {
      color: #8B0000;
      font-size: 30px;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      border-bottom: 1px solid #ab8a62;
      padding-bottom: 15px;
      font-weight: bold;
    }
    .label {
      color: #8B0000;
      font-family: sans-serif;
      font-weight: bold;
    }
    p {
      padding: 0;
      margin: 10px;
    }
  }
}
#poster_warpper {
  overflow: hidden;
}
</style>
